import { CircularProgress, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTypedSelector } from "../hooks/useTypedSelector";
import { tokens } from "../theme";

export const NoData = ({ text }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { isDataFetched } = useTypedSelector((state) => state.uiReducer);
  return (
    <Typography variant="caption" color={colors.black[800]} fontWeight="500">
      {!isDataFetched ? (
        <CircularProgress style={{ color: "#6a27ea" }} />
      ) : (
        text
      )}
    </Typography>
  );
};
